    import React from 'react';
    
    const Introduction = () => {
        return (
            <div>
                giới thiệu
            </div>
        );
    }
    
    export default Introduction;
    